
// Home.js

import React from 'react';

import ScrollableForm from '../components/foundation/ScrollableForm';
import Spacer from '../components/foundation/Spacer';
import Footer from '../components/navigation/Footer';
import TitleField from '../components/text/TitleField';
import SubTitleField from '../components/text/SubTitleField';
import TextField from '../components/text/TextField';
import CenteredImage from '../components/design/CenteredImage';
import NicheWareLogo from '../images/logo/logo512.png';
import CenteredContentPage from '../components/foundation/CenteredContentPage';


import Hero from '../components/home/Hero';
import ProductOverview from '../components/home/ProductsOverview';
import Process from '../components/home/Process';
import ContactUsCard from '../components/design/ContactUsCard';


// Define a functional component named FacilitySelection.
const Home = () => {

    return (
        <>
            <ScrollableForm>
                <Hero/>
                <CenteredContentPage>
                    <ProductOverview/>      
                    <ContactUsCard/>             
                </CenteredContentPage>
                
                
                <Footer/>
            </ScrollableForm>
        </>
    )
};
  
// Export the Home as the default export of this module.
export default Home;
